<template>
  <div>
    <div class="content-header">
      <div class="left">
         <span class="title">绑定屏保</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Select v-model="agent_id" style="width: 160px">
          <Option :value="0">所有</Option>
          <Option v-for="(item,index) in agent" :key="index" :value="item.id">{{item.agent_name}}</Option>
        </Select>
      </div>
      <div class="right">
        <Select v-model="machine_ad_id" style="width: 160px">
          <Option v-for="(item,index) in screen" :key="index" :value="item.id">{{item.name}}</Option>
        </Select>
        <Button type="primary" @click="bind" style="margin-left:5px">绑定</Button>
      </div>
    </div>
    <div>
      <Row>
        <Col span="4" style="margin: 10px 10px 0 0" v-for="(item,index) in machine" :key="index">
          <div @click="chooseMachine(item)">
            <Card :class="{card: true,active: list.indexOf(item.id) >= 0}">
              <div slot="title">{{item.sn}} <small v-if="item.status === 3" style="color: #ed4014">(已过期)</small></div>
              <div>
                <p class="row">学校: {{item.company_name}}</p>
                <p class="row">屏保: {{item.ad_name}}</p>
                <p class="row">站点: {{item.site_name}}</p>
                <p class="row">维护: {{item.repair_name}}</p>
                <p class="row">地区: {{item.province}}-{{item.city}}-{{item.area}}</p>
                <p class="row">地址: {{item.address}}</p>
                <p class="row">详细: {{item.address_detail}}</p>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
      <Spin fix v-if="loading"></Spin>
    </div>
  </div>
</template>

<script>
  import {mapActions,mapGetters} from "vuex"
  export default {
    data() {
      return {
        screen: [],
        machine: [],
        agent: [],
        agent_id: 0,
        machine_ad_id: 0,
        list: [],
        loading:true,
      }
    },
    mounted(){
      this.GetScreenSaver({p:0,l:10000}).then(res => {
        this.screen = res.data
      })
      this.getAgentList({
        p: 0,
        l: 1000,
        cond: 'id',
        value: '',
        is_del: 0,
        senior: '',
        key: 'id',
        order: 'desc'
      }).then(res=>{
        this.agent = res.data;
        this.getAgentMachine();
      })
    },
    methods: {
      bind(){
        let flag = true;
        if(!this.list.length){
          flag = false;
          this.$Message.error("未选择设备")
        }else if(!this.machine_ad_id){
          flag = false;
          this.$Message.error("未选择屏保方案")
        }
        if(flag){
          this.ScreenBind({machine_id: this.list,machine_ad_id: this.machine_ad_id}).then(res=>{
            this.$Message.success("操作成功");
            this.getAgentMachine();
            this.socketSend({ action: 10005, value: { machine_id: this.list,machine_ad_id: this.machine_ad_id } })
            this.list = []
          });
        }
      },
      chooseMachine(data){
        if(data.status === 3){
          this.$Message.error("无法选择已过期设备")
        }else{
          let index = this.list.indexOf(data.id);
          if(index >= 0){
            this.list.splice(index,1)
          }else{
            this.list.push(data.id)
          }
        }
      },
      getAgentMachine(){
        this.AgentMachine({agent_id: this.agent_id}).then(res=>{
          this.machine = res;
          this.loading = false;
        });
      },
      ...mapActions(["AgentMachine","getAgentList","GetScreenSaver","ScreenBind","socketSend"])
    },
    watch: {
      agent_id(n,o){
        this.getAgentMachine()
      }
    }
  }
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
